<template>
  <div class="messangers" :class="{ active: isActive }">
    <div class="shadow"></div>
    <div
      v-for="(link, i) in links"
      :key="link"
      :class="'messanger' + i"
      class="messanger"
      @click="toggle_active"
    >
      <a :href="link"></a>
    </div>
    <div class="messanger2 messanger" @click="toggle_active">
      <a onclick="Chatra('openChat', true)"></a>
    </div>
    <a class="icon" @click="toggle_active"></a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isActive: false,
        links: ['https://telegram.me/Zorra_Support']
      };
    },
    methods: {
      toggle_active() {
        this.isActive = !this.isActive;
      }
    }
  };
</script>

<style lang="scss">
  .messangers {
    transform-origin: center;
    border-radius: 50%;
    position: fixed;
    bottom: 10px;
    right: 0;
    transform: scale(1);
    z-index: 99999999;
    width: 200px;
    height: 200px;
    margin-right: -34.98px;
    margin-bottom: -34.98px;
    pointer-events: none;
    z-index: 90;
    .icon {
      left: 0;
      transform-origin: center;
      cursor: pointer;
      position: absolute;
      background: #f57c00 url('/img/icons/messangers/messangers.png') center no-repeat;
      background-size: 50%;
      border-radius: 50%;
      width: 30%;
      height: 30%;
      margin-left: 35% !important;
      margin-top: 35% !important;
      user-select: none;
      transition: all 200ms ease-out;
      animation: anim_btn 3s linear infinite;
      transform: rotate(0deg);
      pointer-events: all;
    }
    .shadow {
      transform-origin: center;
      position: absolute;
      background-color: #f57c00;
      opacity: 0.3;
      border-radius: 50%;
      width: 30%;
      height: 30%;
      margin-left: 35%;
      margin-top: 35%;
      transition: all 200ms ease-out;
    }
    &.active {
      .messanger {
        pointer-events: all;
      }
    }
    .messanger {
      text-align: left;
      position: absolute;
      width: 18%;
      height: 100%;
      margin-left: 41%;
      transform-origin: 50% 50%;
      user-select: none;
      pointer-events: none;
      a {
        transform-origin: center;
        width: 100%;
        height: 18%;
        position: absolute;
        border-radius: 50%;
        top: 40%;
        transition: all 200ms ease-out;
        opacity: 0;
        cursor: pointer;
      }
    }
    .messanger0 {
      transform: rotate(285deg);
      a {
        background: url('/img/icons/messangers/telegram.png') center;
        background-size: 101%;
        transform: rotate(-285deg);
      }
    }
    .messanger1 {
      transform: rotate(250deg);
      a {
        background: url('/img/icons/messangers/telegram.png') center;
        background-size: 101%;
        transform: rotate(-250deg);
      }
    }
    .messanger2 {
      transform: rotate(320deg);
      a {
        background: url('/img/icons/messangers/chatra.png') center;
        background-size: 101%;
        transform: rotate(-320deg);
      }
    }
    &.active {
      .icon {
        background-color: #f57c00;
        background-image: url('/img/icons/messangers/close.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40%;
        transform: rotate(180deg);
        -webkit-animation: none;
        animation: none;
      }
      .shadow {
        width: 100%;
        height: 100%;
        margin-left: 0%;
        margin-top: 0%;
      }
      .messanger {
        a {
          top: 5%;
          opacity: 1;
        }
      }
    }
    @media screen and (max-width: 767px) {
      width: 160px;
      height: 160px;
    }
  }
  #chatra:not(.chatra--expanded) {
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none;
    transition: none;
  }
  @keyframes anim_btn {
    0% {
      box-shadow: 0 0 0 0 rgba(245, 124, 01, 0), 0 0 0 0 rgba(245, 124, 01, 0.7);
    }
    40% {
      box-shadow: 0 0 0 12.72px rgba(245, 124, 01, 0), 0 0 0 6.36px rgba(245, 124, 01, 0.7);
    }
    80% {
      box-shadow: 0 0 0 25.44px rgba(245, 124, 01, 0), 0 0 0 12.72px rgba(245, 124, 01, 0);
    }
    100% {
      box-shadow: 0 0 0 31.8px rgba(245, 124, 01, 0), 0 0 0 25.44px rgba(245, 124, 01, 0);
    }
  }
</style>
